<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}

.do-copy-floating-tooltip {
    position: fixed;
    z-index: 99999;
    background-color: #37474f;
    color: #fff;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    pointer-events: none;
    transform: translateX(-50%);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, background-color 0.2s ease;
}

.do-copy-floating-tooltip.is-visible {
    opacity: 1;
    visibility: visible;
}

.do-copy-floating-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #37474f;
    transition: border-top-color 0.2s ease;
}

.do-copy-floating-tooltip.copied {
    background-color: #28a745;
}

.do-copy-floating-tooltip.copied::after {
    border-top-color: #28a745;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    #ag-grid-demo .ag-theme-material {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    #ag-grid-demo .ag-theme-material .ag-root-wrapper {
        min-width: 1200px;
    }

    .ag-theme-material .ag-cell {
        line-height: 30px !important;
    }

    .bast-filter-footer {
        flex-direction: column;
        gap: 8px;
    }

    .bast-filter-footer > div {
        width: 100%;
        justify-content: center;
    }

    .bast-filter-footer .vs-button {
        width: 100%;
    }
}
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap items-center justify-between">
                <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
                    <h4>Konfirmasi BAST Transfer Warehouse Vendor</h4>
                </div>
                <div
                    class="flex flex-wrap items-center ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                        >Refresh</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="filterInit"
                        icon="filter_list"
                        >Filter</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="exportExcel"
                        icon="file_download"
                        >Export</vs-button
                    >
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="tableData"
                colResizeDefault="shift"
                :animateRows="false"
                :pagination="false"
                @grid-ready="onGridReady"
                @cell-clicked="onCellClicked"
                @row-double-clicked="onRowDoubleClicked"
            ></ag-grid-vue>
            <p class="text-right hidden md:block">
                <b
                    >Showing {{ dataFrom }} to {{ dataTo }} of
                    {{ dataTotal }} total entries</b
                >
            </p>
            <p class="text-center md:hidden">
                <b
                    >{{ dataFrom }}-{{ dataTo }} of
                    {{ dataTotal }}</b
                >
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
                class="justify-center"
            ></vs-pagination>
        </vx-card>

        <!-- Filter Modal -->
        <vs-popup
            title="Filter"
            :active.sync="showFilter"
        >
            <div class="con-exemple-prompt">
                    <label class="vs-input--label">Tgl DO</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.start_date"
                            :config="{ dateFormat: 'Y-m-d', placeholder: 'Dari' }"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.end_date"
                            :config="{ dateFormat: 'Y-m-d', placeholder: 'Sampai' }"
                        />
                    </vs-col>
                </vs-row>

                <vs-input
                    v-model="filter.do_reference"
                    class="mb-2 w-full"
                    label="Nomor DO"
                    placeholder="Masukkan nomor DO"
                />

                <label class="vs-input--label">Origin</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    placeholder="Pilih origin"
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_origin.data"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>

                <label class="vs-input--label">Destination</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    placeholder="Pilih destination"
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_destination.data"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>

                <vs-input
                    v-model="filter.driver"
                    class="mb-2 w-full"
                    label="Driver"
                    placeholder="Masukkan nama driver"
                />

                <vs-input
                    v-model="filter.vehicle_code"
                    class="mb-2 w-full"
                    label="Nopol"
                    placeholder="Masukkan nomor polisi"
                />
            </div>

            <div class="flex flex-wrap items-center justify-between mt-4 bast-filter-footer">
                <vs-button
                    color="danger"
                    type="border"
                    @click="resetFilter"
                    >Reset Filter</vs-button
                >
                <div class="flex items-center">
                    <vs-button
                        color="primary"
                        type="border"
                        class="mr-2"
                        @click="showFilter = false"
                        >Cancel</vs-button
                    >
                    <vs-button
                        color="primary"
                        @click="onFilterApply"
                        >Apply</vs-button
                    >
                </div>
            </div>
        </vs-popup>

        <!-- Konfirmasi Modal -->
        <vs-prompt
            @accept="submitConfirm"
            title="Konfirmasi BAST"
            :active.sync="showConfirm"
            acceptText="Submit"
            cancelText="Batal"
        >
            <div class="con-exemple-prompt">
                <div class="mb-3">
                    <label class="vs-input--label pl-0">Nomor DO</label>
                    <p class="font-bold">{{ confirmData.do_reference }}</p>
                </div>
                <div class="mb-3">
                <label class="vs-input--label pl-0">Tgl DO</label>
                    <p>{{ confirmData.posting_date }}</p>
                </div>
                <div class="mb-3">
                    <label class="vs-input--label pl-0">Origin</label>
                    <p>{{ confirmData.origin_name }}</p>
                </div>
                <div class="mb-3">
                    <label class="vs-input--label pl-0">Destination</label>
                    <p>{{ confirmData.destination_name }}</p>
                </div>
                <div class="mb-3">
                    <label class="vs-input--label pl-0">Driver</label>
                    <p>{{ confirmData.driver_name }}</p>
                </div>
                <div class="mb-3">
                    <label class="vs-input--label pl-0">Nopol</label>
                    <p>{{ confirmData.vehicle_code }}</p>
                </div>

                <label class="vs-input--label pl-0">Tgl Konfirmasi</label>
                <flat-pickr
                    class="w-full p-2 mb-3"
                    v-model="confirmData.confirmation_date"
                    :config="dateTimePickerConfig"
                />

                <label class="vs-input--label pl-0">Tgl Tiba Gudang Vendor</label>
                <flat-pickr
                    class="w-full p-2 mb-3"
                    v-model="confirmData.arrival_date"
                    :config="dateTimePickerConfig"
                />

                <vs-input
                    v-model="confirmData.name"
                    class="w-full"
                    label="Nama Konfirmator"
                    placeholder="Masukkan nama konfirmator"
                />
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
    components: {
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            isLoading: false,
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            tableData: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            showFilter: false,
            showConfirm: false,
            filter: {
                fetchCount: 0,
                start_date: null,
                end_date: null,
                do_reference: "",
                origin_id: null,
                destination_id: null,
                driver: "",
                vehicle_code: "",
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: "master/customers",
                objectKey: "name",
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: "master/customers",
                objectKey: "name",
            },
            confirmData: {
                do_id: null,
                do_reference: "",
                posting_date: "",
                origin_name: "",
                destination_name: "",
                driver_name: "",
                vehicle_code: "",
                confirmation_date: null,
                arrival_date: null,
                name: "",
            },
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
            }
            this.updatePinnedColumns(val <= 768);
        },
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function () {
            this.fetchData();
        },
    },
    computed: {
        dateTimePickerConfig() {
            const self = this;
            return {
                dateFormat: "Y-m-d H:i",
                enableTime: true,
                time_24hr: true,
                placeholder: "Pilih tanggal & jam",
                onReady: function (selectedDates, dateStr, instance) {
                    const container = instance.calendarContainer;
                    if (container.querySelector(".fp-pilih-btn")) return;

                    const btn = document.createElement("div");
                    btn.className = "fp-pilih-btn";
                    btn.innerHTML = "Pilih";
                    btn.style.cssText =
                        "width:100%;text-align:center;padding:8px 0;cursor:pointer;background:#7367f0;color:#fff;border-radius:0 0 5px 5px;font-weight:600;font-size:13px;";
                    btn.addEventListener("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        instance.close();
                    });
                    container.appendChild(btn);
                },
            };
        },
    },
    methods: {
        updatePinnedColumns(isMobile) {
            if (!this.gridOptions.columnApi) return;
            this.gridOptions.columnApi.setColumnPinned(
                "do_reference",
                isMobile ? null : "left"
            );
            this.gridOptions.columnApi.setColumnPinned(
                "id",
                isMobile ? null : "right"
            );
        },
        onGridReady(params) {
            this.gridApi = params.api;
            const colApi = this.gridOptions.columnApi;
            const dateCols = ["do_reference", "posting_date", "confirmation_date", "arrival_date"];
            dateCols.forEach((colName) => {
                colApi.autoSizeColumn(colApi.getColumn(colName));
            });
            this.updatePinnedColumns(this.$store.state.windowWidth <= 768);
        },
        buildQueryParams() {
            const params = {};
            if (this.filter.start_date) params.start_date = this.filter.start_date;
            if (this.filter.end_date) params.end_date = this.filter.end_date;
            if (this.filter.do_reference) params.do_reference = this.filter.do_reference;
            if (this.filter.origin_id) params.origin_id = this.filter.origin_id;
            if (this.filter.destination_id) params.destination_id = this.filter.destination_id;
            if (this.filter.driver) params.driver = this.filter.driver;
            if (this.filter.vehicle_code) params.vehicle_code = this.filter.vehicle_code;
            return params;
        },
        fetchData() {
            this.isLoading = true;
            this.setFilter(this.filter);
            const params = this.buildQueryParams();
            params.page = this.currentPage;

            this.$http
                .get("tvd/outbound/deliveryordervendor/", { params })
                .then((resp) => {
                    const payload = resp.data.data || resp.data;
                    this.tableData = (payload.data || []).map((item) =>
                        this.flattenRow(item)
                    );
                    this.totalPage = payload.last_page;
                    this.dataTotal = payload.total;
                    this.dataFrom = payload.from;
                    this.dataTo = payload.to;
                    this.isLoading = false;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            if (this.gridOptions.columnApi) {
                                const colApi = this.gridOptions.columnApi;
                                const dateCols = ["do_reference", "posting_date", "confirmation_date", "arrival_date"];
                                dateCols.forEach((colName) => {
                                    colApi.autoSizeColumn(colApi.getColumn(colName));
                                });
                            }
                        }, 50);
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.fetchData();
                        },
                        acceptText: "Yes",
                        cancelText: "No",
                    });
                });
        },
        refreshData() {
            this.fetchData();
        },
        onFilterApply() {
            this.currentPage = 1;
            this.fetchData();
            this.showFilter = false;
        },
        resetFilter() {
            this.filter.start_date = null;
            this.filter.end_date = null;
            this.filter.do_reference = "";
            this.filter.origin_id = null;
            this.filter.destination_id = null;
            this.filter.driver = "";
            this.filter.vehicle_code = "";
            this.currentPage = 1;
            this.fetchData();
            this.showFilter = false;
        },
        filterInit() {
            if (this.ddl_origin.data.length <= 1) {
                this.isLoading = true;
                this.fetchDropdowns()
                    .then(() => {
                        this.isLoading = false;
                        this.showFilter = true;
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.showFilter = true;
                    });
            } else {
                this.showFilter = true;
            }
        },
        fetchDropdowns() {
            return this.$http
                .post("master/customers")
                .then((resp) => {
                    const raw = resp.data.data || resp.data || [];
                    const list = Array.isArray(raw) ? raw : [];

                    this.ddl_origin.data = [{ id: null, name: "Any" }].concat(list);
                    this.ddl_destination.data = [{ id: null, name: "Any" }].concat(list);
                })
                .catch(() => {
                    if (this.ddl_origin.data.length === 0) {
                        this.ddl_origin.data = [{ id: null, name: "Any" }];
                    }
                    if (this.ddl_destination.data.length === 0) {
                        this.ddl_destination.data = [{ id: null, name: "Any" }];
                    }
                });
        },
        exportExcel() {
            this.isLoading = true;
            const params = this.buildQueryParams();

            this.$http
                .get("tvd/outbound/deliveryordervendor/export", {
                    params,
                    responseType: "blob",
                })
                .then((response) => {
                    var blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    this.isLoading = false;
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Konfirmasi-BAST-Transfer-Warehouse-Vendor.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    this.handleError(error);
                    this.isLoading = false;
                });
        },
        printBast(id) {
            this.isLoading = true;
            this.$http
                .post(
                    `/tvd/outbound/deliveryorder/print/${id}`,
                    {},
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    window.open(URL.createObjectURL(blob));
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.handleError(error);
                    this.isLoading = false;
                });
        },
        getTodayDateTime() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const day = String(today.getDate()).padStart(2, "0");
            const hours = String(today.getHours()).padStart(2, "0");
            const minutes = String(today.getMinutes()).padStart(2, "0");
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        openConfirmModal(data) {
            this.confirmData.do_id = data.id;
            this.confirmData.do_reference = data.do_reference;
            this.confirmData.posting_date = data.posting_date;
            this.confirmData.origin_name = data.origin_name;
            this.confirmData.destination_name = data.destination_name;
            this.confirmData.driver_name = data.driver_name;
            this.confirmData.vehicle_code = data.vehicle_code;

            const isConfirmed = data.confirmation_date && data.confirmation_date !== "-";
            this.confirmData.confirmation_date = isConfirmed ? data.confirmation_date : this.getTodayDateTime();
            this.confirmData.arrival_date = isConfirmed && data.arrival_date && data.arrival_date !== "-" ? data.arrival_date : null;
            this.confirmData.name = isConfirmed && data.confirmer_name && data.confirmer_name !== "-" ? data.confirmer_name : "";

            if (!this.confirmData.name) {
                const user = (this.$store.state.user || {}).user || {};
                this.confirmData.name = user.name || user.username || "";
            }

            this.showConfirm = true;
        },
        submitConfirm() {
            if (!this.confirmData.name) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Nama Konfirmator harus diisi",
                });
                return false;
            }
            if (!this.confirmData.confirmation_date || !this.confirmData.arrival_date) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Tanggal & Jam Konfirmasi dan Tanggal & Jam Tiba harus diisi",
                });
                return false;
            }

            this.isLoading = true;
            this.$http
                .post("tvd/outbound/deliveryordervendor/confirm", {
                    do_id: this.confirmData.do_id,
                    confirmation_date: this.confirmData.confirmation_date,
                    arrival_date: this.confirmData.arrival_date,
                    name: this.confirmData.name,
                })
                .then(() => {
                    this.isLoading = false;
                    this.$vs.notify({
                        color: "success",
                        title: "Konfirmasi Berhasil",
                        text: "BAST berhasil dikonfirmasi",
                    });
                    this.fetchData();
                })
                .catch((error) => {
                    this.handleError(error);
                    this.isLoading = false;
                });
        },
        onRowDoubleClicked(params) {
            if (params.data) {
                this.openConfirmModal(params.data);
            }
        },
        onCellClicked(params) {
            const target = params.event && params.event.target
                ? params.event.target.closest("[data-action]")
                : null;

            if (!target) return;

            const action = target.getAttribute("data-action");
            const id = target.getAttribute("data-id");

            if (action === "print-bast") {
                this.printBast(id);
            } else if (action === "confirm") {
                const row = (this.tableData || []).find(
                    (item) => item.id == id
                );
                if (row) {
                    this.openConfirmModal(row);
                }
            } else if (action === "copy-do") {
                const doRef = target.getAttribute("data-do-reference");
                const x = params.event ? params.event.clientX : 0;
                const y = params.event ? params.event.clientY : 0;
                this.copyToClipboard(doRef, x, y);
            }
        },
        hideTooltip() {
            clearTimeout(this._hoverDelayTimer);
            this._hoverDelayTimer = null;
            this.tooltipEl.classList.remove("is-visible");
        },
        showCopiedTooltip(x, y) {
            if (!this.tooltipEl) return;

            clearTimeout(this._hoverDelayTimer);
            this._hoverDelayTimer = null;

            this.tooltipEl.style.left = x + "px";
            this.tooltipEl.style.top = (y - 35) + "px";
            this.tooltipEl.textContent = "Tersalin";
            this.tooltipEl.classList.add("copied");
            this.tooltipEl.dataset.copied = "true";

            if (!this.tooltipEl.classList.contains("is-visible")) {
                this.tooltipEl.classList.add("is-visible");
            }

            clearTimeout(this._copyTooltipTimer);
            this._copyTooltipTimer = setTimeout(() => {
                this.tooltipEl.dataset.copied = "false";
                this.tooltipEl.classList.remove("copied");
                this.tooltipEl.classList.remove("is-visible");
            }, 1500);
        },
        copyToClipboard(text, x, y) {
            if (!text) return;

            const onSuccess = () => this.showCopiedTooltip(x, y);

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text)
                    .then(onSuccess)
                    .catch(() => this.fallbackCopy(text, onSuccess));
            } else {
                this.fallbackCopy(text, onSuccess);
            }
        },
        fallbackCopy(text, onSuccess) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand("copy");
                onSuccess();
            } catch (e) {
                // silently fail
            }
            document.body.removeChild(textarea);
        },
        flattenRow(item) {
            return {
                id: item.id,
                do_reference: item.do_reference,
                posting_date: item.posting_date,
                origin_name: item.outbound && item.outbound.origin ? item.outbound.origin.name : "-",
                destination_name: item.outbound && item.outbound.destination ? item.outbound.destination.name : "-",
                tv_count: item.tv_qty,
                bracket_count: item.bracket_qty,
                driver_name: item.transport_unloading && item.transport_unloading.vehicle ? item.transport_unloading.vehicle.driver : "-",
                vehicle_code: item.transport_unloading && item.transport_unloading.vehicle ? item.transport_unloading.vehicle.vehicle_code : "-",
                confirmation_date: item.vendor_confirmation ? item.vendor_confirmation.confirmation_date : "-",
                confirmer_name: item.vendor_confirmation ? item.vendor_confirmation.name : "-",
                arrival_date: item.vendor_confirmation ? item.vendor_confirmation.arrival_date : "-",
            };
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.fetchData();

        this.tooltipEl = document.createElement("div");
        this.tooltipEl.className = "do-copy-floating-tooltip";
        document.body.appendChild(this.tooltipEl);

        this._hoverDelayTimer = null;
        this._copyTooltipTimer = null;

        this.handleTooltipMove = (e) => {
            const cell = e.target.closest(".do-copy-cell");
            if (cell) {
                if (this.tooltipEl.dataset.copied !== "true") {
                    this.tooltipEl.style.left = e.clientX + "px";
                    this.tooltipEl.style.top = (e.clientY - 35) + "px";

                    if (!this.tooltipEl.classList.contains("is-visible") && !this._hoverDelayTimer) {
                        clearTimeout(this._hoverDelayTimer);
                        this._hoverDelayTimer = setTimeout(() => {
                            this.tooltipEl.textContent = "Klik untuk salin";
                            this.tooltipEl.classList.remove("copied");
                            this.tooltipEl.classList.add("is-visible");
                            this._hoverDelayTimer = null;
                        }, 500);
                    }
                }
            } else {
                if (this.tooltipEl.dataset.copied !== "true") {
                    this.hideTooltip();
                }
            }
        };

        this.handleTooltipLeave = (e) => {
            const cell = e.target.closest && e.target.closest(".do-copy-cell");
            if (!cell && this.tooltipEl.dataset.copied !== "true") {
                this.hideTooltip();
            }
        };

        document.addEventListener("mousemove", this.handleTooltipMove);
        document.addEventListener("mouseout", this.handleTooltipLeave);
    },
    beforeDestroy() {
        clearTimeout(this._hoverDelayTimer);
        clearTimeout(this._copyTooltipTimer);
        document.removeEventListener("mousemove", this.handleTooltipMove);
        document.removeEventListener("mouseout", this.handleTooltipLeave);
        if (this.tooltipEl && this.tooltipEl.parentNode) {
            this.tooltipEl.parentNode.removeChild(this.tooltipEl);
        }
    },
    beforeMount() {
        const filter = this.getFilter();

        if (filter) {
            this.filter = filter;
            this.filter.fetchCount = 0;
        }

        if (this.isLoading) {
            this.$vs.loading();
        }

        this.columnDefs = [
            {
                headerName: "Nomor DO",
                field: "do_reference",
                filter: true,
                width: 150,
                pinned: "left",
                cellRenderer: (params) => {
                    const value = params.value || "";
                    return `
                        <div
                            class="do-copy-cell"
                            data-action="copy-do"
                            data-do-reference="${value}"
                            style="cursor: pointer; display: block; width: 100%; height: 100%;"
                        >
                            <span>${value}</span>
                        </div>
                    `;
                },
            },
            {
                headerName: "Tgl DO",
                field: "posting_date",
                filter: true,
                width: 150,
            },
            {
                headerName: "Origin",
                field: "origin_name",
                filter: true,
                width: 130,
            },
            {
                headerName: "Destination",
                field: "destination_name",
                filter: true,
                width: 130,
            },
            {
                headerName: "TV",
                field: "tv_count",
                filter: true,
                width: 80,
            },
            {
                headerName: "Bracket",
                field: "bracket_count",
                filter: true,
                width: 90,
            },
            {
                headerName: "Driver",
                field: "driver_name",
                filter: true,
                width: 130,
            },
            {
                headerName: "Nopol",
                field: "vehicle_code",
                filter: true,
                width: 110,
            },
            {
                headerName: "Tgl Konfirmasi",
                field: "confirmation_date",
                filter: true,
                width: 160,
            },
            {
                headerName: "Nama Konfirmator",
                field: "confirmer_name",
                filter: true,
                width: 140,
            },
            {
                headerName: "Tgl Tiba Gudang Vendor",
                field: "arrival_date",
                filter: true,
                width: 180,
            },
            {
                headerName: "Aksi",
                field: "id",
                sortable: false,
                width: 220,
                pinned: "right",
                cellRenderer: (params) => {
                    const id = params.value;
                    const isConfirmed = params.data.confirmation_date && params.data.confirmation_date !== "-";
                    const confirmLabel = isConfirmed ? "Ubah Konfirmasi" : "Konfirmasi";
                    const confirmColor = isConfirmed ? "warning" : "success";

                    return `
                        <div style="display: flex; gap: 6px; align-items: center; justify-content: flex-start; height: 100%; padding: 0; margin: 0;">
                            <button
                                style="margin: 0; padding: 6px 12px; cursor: pointer; font-size: 11px; border: none; border-radius: 5px; color: #fff;"
                                class="vs-component vs-button vs-button-primary vs-button-filled"
                                data-action="print-bast"
                                data-id="${id}"
                                title="Print BAST"
                            >
                                Print
                            </button>
                            <button
                                style="margin: 0; padding: 6px 12px; cursor: pointer; font-size: 11px; border: none; border-radius: 5px; color: #fff;"
                                class="vs-component vs-button vs-button-${confirmColor} vs-button-filled"
                                data-action="confirm"
                                data-id="${id}"
                                title="${confirmLabel}"
                            >
                                ${confirmLabel}
                            </button>
                        </div>
                    `;
                },
            },
        ];

        this.gridOptions.getRowHeight = function () {
            return 45;
        };

        this.gridOptions.suppressRowClickSelection = true;
        this.gridOptions.suppressCellSelection = true;
    },
};
</script>
